import assign from 'lodash/assign';
import isFunction from 'lodash/isFunction';

import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';

import template from './nextStepNotice.html';
import './nextStepNotice.scss';

import FOUNDER_GUIDE_STEPS from './founderGuideNextStep.data';

export const NextStepNoticeModule = angular
    .module('app.components.nextStepNotice', [LaunchDarklyServiceModule])
    .component('nextStepNotice', {
        template,
        bindings: {
            noticeTitle: '<',
            titleData: '<',
            subtitle: '<',
            ctaLabel: '<',
            link: '<',
            url: '<',
            secondaryCtaLabel: '<',
            secondaryLink: '<',
            secondaryUrl: '<',
            color: '<',
            backgroundColor: '<',
            fullWidth: '<',
            showInitialMessage: '<',
            initialMessage: '<',
            initialMessageLink: '<',
            initialMessageColor: '<',
            animateIn: '<',
            founderGuideStep: '<',
            founderGuideNextStep: '<'
        },
        controller: class NextStepNoticeController {
            constructor($state, launchDarklyService) {
                assign(this, {
                    $state,
                    launchDarklyService,
                    hasFounderGuide: false,
                    cardStyle: {},
                    iconStyle: {},
                    hstyle: {}
                });
            }

            $onInit() {
                this.backgroundColor = this.backgroundColor || 'transparent';
                if (this.color) this.setElementColors();

                if (this.initialMessageColor) {
                    this.messageStyle = { backgroundColor: this.initialMessageColor };
                }

                this.launchDarklyService.getFeature('founder-guide').then((feature) => {
                    this.hasFounderGuide = feature;
                    this.setFounderGuideContent();
                });
            }

            $onChanges(changes) {
                if (changes.founderGuideNextStep) {
                    this.setFounderGuideContent();
                    this.setFounderGuideNextStep();
                }

                if (changes.color) {
                    this.setElementColors();
                }
            }

            setElementColors() {
                this.cardStyle = { borderColor: this.color };
                this.iconStyle = { backgroundColor: this.color };
                this.hstyle = { color: this.color };
            }

            goTo(link) {
                if (!link) return;

                if (isFunction(link)) {
                    link();
                } else {
                    let appCard;
                    [link, appCard] = link.split('@');
                    this.$state.go(link, { installApp: appCard });
                }
            }

            setFounderGuideContent() {
                if (!this.hasFounderGuide) return;

                const step = FOUNDER_GUIDE_STEPS.steps[this.founderGuideStep];
                if (step) {
                    this.isFounderGuideNextStep = true;
                    this.noticeTitle = step.noticeTitle;
                    this.subtitle = step.subtitle;
                    this.ctaLabel = step.ctaLabel;
                    this.link = step.link;
                    this.url = undefined;
                    this.secondaryCtaLabel = step.secondaryCtaLabel;
                    this.secondaryLink = step.secondaryLink;
                    this.secondaryUrl = step.secondaryUrl;

                    this.iconStyle = { backgroundColor: 'transparent' };

                    if (this.founderGuideStep === 'product' || this.founderGuideStep === 'page') {
                        this.showInitialMessage = true;
                        this.setFounderGuideNextStep();
                    }
                }
            }

            setFounderGuideNextStep() {
                const step = FOUNDER_GUIDE_STEPS.nextsteps[this.founderGuideNextStep];
                if (step) {
                    this.initialMessageLink = step.initialMessageLink;
                    this.initialMessage = step.initialMessage;
                }
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/nextStepNotice/nextStepNotice.component.js